import React from 'react'
import { connect } from 'react-redux'
import AttractionActions from '../../Redux/AttractionRedux'
import Select from 'react-select'

class DownloadAttractionData extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selected: '',
      filter: {
        destinationId: ''
      }
    }
  }

  _inputChange = (event, field) => {
    let filter = {...this.state.filter}
    if (field === 'destinationId') {
      filter.destinationId = event.value
      this.setState({ selected: event, filter })
    } else {
      let value = event.target.value
      filter[field] = value
      this.setState({ filter })
    }
  }

  _submit = (event) => {
    event.preventDefault()
    let data = {
      ...this.state.filter
    }
    this.props.download(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    const { destination } = this.props

    // populate destination selector
    let destinationPicker = []
    destination.data && destination.data.length &&
    destination.data.map((item, i) => {
      destinationPicker[i] = {
        value: item.id,
        label: item.name
      }
      return destinationPicker
    })

    return (
      <div className='section' style={{ width: '30vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>
            Download Attraction Data
            {
              (destination.fetching || destination.processing) &&
              <div className='badge badge-info ml-2'>
                {destination.fetching ? 'Loading' : 'Processing'}
                ...
              </div>
            }
          </h4>
        </div>
        <form onSubmit={(event) => this._submit(event)} className='section'>
          <div className='form-group'>
            <label className='control-label mr-2'>Pick a Destination</label>
            <Select
              options={destinationPicker}
              name='attraction-picker'
              placeholder='All Destination'
              value={this.state.selected}
              onChange={(selected) => this._inputChange(selected, 'destinationId')}
            />
          </div>
          <div>
            <div className='text-center'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>
                <i className='fa fa-download' />Download
              </button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  destination: state.destination
})
const dispatchToProps = (dispatch) => ({
  download: (filter) => dispatch(AttractionActions.downloadAttractionDataRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(DownloadAttractionData)



// WEBPACK FOOTER //
// ./src/Containers/Attraction/DownloadAttractionData.js